<template>
  <div class="report-filter object-status">
    <div class="ms-help">
      Статус задачи:
    </div>
    <i-select v-model="status" style="width: 160px;">
      <i-option
        v-for="item in statuses"
        :value="item.id"
        :key="item.id"
      >
        {{ item.name }}
      </i-option>
    </i-select>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      statuses: []
    }
  },
  computed: {
    status: {
      get () {
        return this.$store.state.reports.objectStatus
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'objectStatus',
          value
        })
      }
    }
  },
  async created () {
    try {
      const url = `objectInfo/${this.type}_statuses`
      const statuses = await this.$store.dispatch('GET_REQUEST', { url })

      this.statuses = [
        {
          id: 'all',
          name: 'Все'
        },
        ...statuses
      ]
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="less">
.object-status {
  display: flex;
  align-items: center;

  .ms-help {
    margin-right: 8px;
  }
}
</style>
